import React, { Component, Fragment } from "react"
import { withStyles } from "@material-ui/core/styles"
import { compose } from "recompose"
import styles from "./styles"
import {
  toggleChangeRepresentativeDialog,
  deleteShoot,
  getShootbyId,
  setRoleForCrew,
  createShootGlue,
  toggleRoleDialog,
  toggleShootDialog,
} from "../../actions/shoots"
import { sendDeletedShootEmail } from "../../actions/crew"
import { connect } from "react-redux"
import {
  Typography,
  Button,
  Popover,
  Tooltip,
  Hidden,
  Fab,
  CircularProgress,
} from "@material-ui/core"
import update from "immutability-helper"
import Context from "./context"
import { clearCrewFromChip } from "../../actions/crew"
import { updateShoot } from "../../actions/shoots"
import LoadingButton from "../../components/LoadingButton"
import AddRoleDialog from "../../components/AddRoleDialog"
import CreateUserDialog from "../../components/CreateUserDialog/index"
import ConfirmSaveShootDialog from "../../components/ConfirmSaveShootDialog/index"
import BackspaceIcon from "@material-ui/icons/Backspace"
import DeleteIcon from "@material-ui/icons/Delete"
import SettingsBackupRestoreIcon from "@material-ui/icons/SettingsBackupRestore"
import IconButton from "@material-ui/core/IconButton"
import SaveIcon from "@material-ui/icons/Save"
import { openSnackBar } from "../../actions/snack-bar"
import ChangeRepresentativeDialog from "../../components/ChangeRepresentativeDialog"
import AddClientCompanyDialog from "../../components/AddClientCompanyDialog/index"

let pages = []
const folder = require.context("./pages/", false, /\d+\.js$/)
folder.keys().map((x, i) => {
  const num = Number(x.match(/(\d)/)[0])
  pages[i] = { num, component: folder(x).default }
  return x
})

const whatToShow = state => {
  // tabs start at index 0
  const page = state.currentTab + 1
  let component = null
  pages.forEach(x => {
    if (page === x.num) {
      component = React.createElement(x.component, {
        setState: e => {
          state.setState({ ...e })
        },
        updateShootState: e => {
          state.setState({ ...e, dirty: true })
        },
        dispatch: e => state.dispatch(e),
        setSelectUser: e => state.setState({ selectUser: e }),
      })
    }
  })
  return component
}

class ShootIndex extends Component {
  render() {
    const { props } = this
    const {
      classes,
      authenticatedUser,
      activeCompany,
      dialogOpen,
      shoot,
      dirty,
      working,
      popover,
      setState,
      save,
      dispatch,
      changeRepresentativeDialogOpen,
      onChangeActiveRepresentative,
    } = props

    // let canDelete = false
    // if (shoot && shoot.roles) {
    //   canDelete =
    //     shoot.roles.length === 0 &&
    //     (shoot.creator_id === authenticatedUser.id ||
    //       (activeCompany !== null && activeCompany === shoot.company_id))
    // }
    let isAd = false
    this.props.authenticatedUser.companies.map(company => {
      if (company.name === "Assignment Desk") {
        company.managers.map(manager => {
          if (manager.id === this.props.authenticatedUser.id) {
            isAd = true
          }
        })
      }
    })
    // Making sure only shoot owners and AD users have deletetion privileges
    let canDelete = false
    if (shoot && shoot.roles) {
      if (this.props.shoot.creator_id !== this.props.authenticatedUser.id) {
        if (isAd === false) {
          canDelete = false
        } else if (shoot.roles.length === 0) {
          canDelete = true
        } else {
          canDelete = false
        }
      } else if (shoot.roles.length === 0) {
        canDelete = true
      } else {
        canDelete = false
      }
    }
    let canCancel = false
    if (shoot && shoot.status) {
      canCancel = shoot.status !== "cancelled"
    }
    //company user id needs to have a value to save if not payments will not work
    const showSave = dirty && shoot.company_user_id !== null

    const openDialog = (shootId, dialog) => {
      this.props.dispatch(clearCrewFromChip())
      this.props.dispatch(setRoleForCrew())
      if (dialog === "role") {
        this.props.dispatch(toggleRoleDialog({ open: true, id: shootId }))
      } else if (dialog === "crew-member") {
        let roleData = {
          role_id: 3788,
          name: "CREW MEMBER",
          shoot_id: shootId,
          expenses: [],
        }
        this.props.dispatch(setRoleForCrew(roleData))
        this.props.dispatch(
          toggleShootDialog({ open: true, id: shootId, crewMember: true })
        )
      } else {
        this.props.dispatch(toggleShootDialog({ open: true, id: shootId }))
      }
    }

    const saveAndOpenDialog = (shootId, dialog) => {
      const { state, props } = this
      const { shoot } = state
      const clientId = props.createdClient
        ? props.createdClient.id
        : shoot.client_id
      const producerId = props.createdProducer
        ? props.createdProducer.id
        : shoot.producer
      let newShoot = { ...shoot, client_id: clientId, producer: producerId }
      const handleError = err => {
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving the shoot details",
          })
        )
        this.setState({ working: false })
        this.props.dispatch(clearCrewFromChip())
        this.props.dispatch(setRoleForCrew())
        if (dialog === "role") {
          this.props.dispatch(toggleRoleDialog({ open: true, id: shootId }))
        } else {
          this.props.dispatch(toggleShootDialog({ open: true, id: shootId }))
        }
      }
      newShoot.location = JSON.stringify(newShoot.location)
      this.setState({ working: true })
      this.saveEquipment()
        .then(res => {
          if (typeof newShoot.producer === "object" && newShoot.producer) {
            newShoot.producer = newShoot.producer.id
            this.props.dispatch(
              createShootGlue(shoot.id, "roles", {
                available: true,
                client_rate: 0,
                crew_rate: 0,
                role_id: 11,
                name: "PRODUCER",
                requested: true,
                user_id: newShoot.producer,
              })
            )
          }

          if (typeof newShoot.start_date !== "string") {
            newShoot.start_date = new Date(
              newShoot.start_date.toLocaleDateString("en-US")
            )
          }

          if (typeof newShoot.end_date !== "string") {
            newShoot.end_date = new Date(
              newShoot.end_date.toLocaleDateString("en-US")
            )
          }
          props
            .dispatch(
              updateShoot(newShoot.id, { ...newShoot, client_id: clientId })
            )
            .then(e => {
              this.props.dispatch(
                openSnackBar({ message: "Shoot details saved" })
              )
              this.setState({ working: false, dirty: false })
              this.props.dispatch(clearCrewFromChip())
              this.props.dispatch(setRoleForCrew())
              if (dialog === "role") {
                this.props.dispatch(
                  toggleRoleDialog({ open: true, id: shootId })
                )
              } else {
                this.props.dispatch(
                  toggleShootDialog({ open: true, id: shootId })
                )
              }
              return true
            })
            .catch(handleError)
        })
        .catch(handleError)
    }
    return (
      <Fragment>
        <Fragment>
          <div className={classes.detailsContainer}>
            {shoot &&
              shoot.id &&
              whatToShow({
                dispatch,
                setState,
                currentTab: this.context.currentTab,
              })}
          </div>

          {/* WEB VIEW */}
          <Hidden smDown>
            {showSave && (
              <div className={classes.saveButton}>
                <LoadingButton
                  variant="contained"
                  color="primary"
                  onClick={save()}
                  working={working}
                >
                  Save Shoot Details
                </LoadingButton>
              </div>
            )}
          </Hidden>

          {/* MOBILE VIEW */}
          <Hidden mdUp>
            {showSave && (
              <Fab
                color={working ? "" : "primary"}
                className={classes.legendButton}
                onClick={save()}
              >
                {working ? (
                  <CircularProgress color="primary" />
                ) : (
                  <SaveIcon style={{ color: "white" }} />
                )}
              </Fab>
            )}
          </Hidden>
        </Fragment>

        <Popover
          id={"areYouSure"}
          open={Boolean(popover.anchor)}
          anchorEl={popover.anchor}
          onClose={e => {
            popover.func(false)
            setState({
              popover: {
                anchor: null,
                func: () => "",
              },
            })
          }}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <Typography style={{ margin: "8px" }}>Are You Sure?</Typography>
            <div style={{ display: "flex" }}>
              <Button
                onClick={e => {
                  popover.func(false)
                  setState({
                    popover: {
                      anchor: null,
                      func: () => "",
                    },
                  })
                }}
              >
                No
              </Button>
              <Button
                onClick={e => {
                  popover.func(true)
                  setState({
                    popover: {
                      anchor: null,
                      func: () => "",
                    },
                  })
                }}
                color="primary"
              >
                Yes
              </Button>
            </div>
          </div>
        </Popover>
        {!dialogOpen && (
          <CreateUserDialog
            onSaveUser={res => {
              this.context.selectUser(res.id, this.context.currentUpdateRole)
              setState({ currentUpdateRole: null })
            }}
          />
        )}
        <ConfirmSaveShootDialog
          shoot={shoot}
          working={working}
          onSaveShoot={() => save()}
        />
        <AddRoleDialog
          setNewShoot={shootData => {
            this.props.getShoot(shootData)
          }}
        />

        {/* MOBILE VIEW */}
        <Hidden mdUp>
          {shoot && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                backgroundColor: "#f8f8f8",
                position: "sticky",
                bottom: 0,
                padding: "15px",
              }}
            >
              <div style={{ display: "flex" }}>
                <Tooltip
                  placement="top"
                  title={
                    !shoot ||
                    (shoot &&
                      shoot.roles.filter(x => x.available === 1).length > 0)
                      ? "mark all crew as not available"
                      : canCancel
                        ? "this will cancel the shoot"
                        : "this will restore the shoot"
                  }
                >
                  <div>
                    <IconButton
                      disabled={
                        !shoot ||
                        (shoot &&
                          shoot.roles.filter(x => x.available === 1).length > 0)
                      }
                      onClick={e => {
                        setState({
                          popover: {
                            func: e => {
                              if (e) {
                                const newStatus = canCancel ? "cancelled" : null
                                setState({
                                  status: newStatus,
                                })
                                dispatch(
                                  updateShoot(shoot.id, {
                                    status: newStatus,
                                  })
                                ).then(res => {
                                  let shootId = window.location.pathname
                                    .match(/\d+/g)
                                    .map(Number)
                                  dispatch(getShootbyId(shootId))
                                  window.location.href =
                                    window.location.pathname
                                })
                              }
                            },
                            anchor: e.currentTarget,
                          },
                        })
                      }}
                      style={{ marginRight: "16px" }}
                    >
                      {canCancel || !shoot ? (
                        <BackspaceIcon
                          className={
                            canCancel || !shoot ? classes.iconButton : {}
                          }
                        />
                      ) : (
                        <SettingsBackupRestoreIcon
                          className={
                            !canCancel || shoot ? classes.iconButton : {}
                          }
                        />
                      )}
                    </IconButton>
                  </div>
                </Tooltip>
                <Tooltip
                  placement="top"
                  title={
                    canDelete
                      ? "this will delete the shoot forever"
                      : shoot && shoot.roles && shoot.roles.length === 0
                        ? "you do not have enough access to remove this shoot"
                        : "remove all positions from the shoot first"
                  }
                >
                  <div>
                    <IconButton
                      disabled={!canDelete}
                      onClick={e => {
                        setState({
                          popover: {
                            func: e =>
                              e
                                ? dispatch(deleteShoot(shoot.id))
                                    .then(res => {
                                      if (activeCompany) {
                                        this.props.history.push("/shoots")
                                      } else {
                                        this.props.history.push("/my-shoots")
                                      }
                                    })
                                    .then(res => {
                                      dispatch(
                                        sendDeletedShootEmail({
                                          subject: "test",
                                          to: "test",
                                          message: `The shoot ${
                                            shoot.name
                                          } with ID ${
                                            shoot.id
                                          } has been deleted. You can view its data in the deleted_shoots table. 
                                          The shoot was deleted by ${
                                            this.props.authenticatedUser
                                              .first_name
                                          } ${
                                            this.props.authenticatedUser
                                              .last_name
                                          }, with a user ID of ${
                                            this.props.authenticatedUser.id
                                          }`,
                                        })
                                      )
                                    })
                                : "",
                            anchor: e.currentTarget,
                          },
                        })
                      }}
                      style={{ marginRight: "16px" }}
                    >
                      <DeleteIcon className={classes.iconButton} />
                    </IconButton>
                  </div>
                </Tooltip>
              </div>

              <div style={{ display: "flex" }}>
                <Fragment>
                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    onClick={e =>
                      dirty
                        ? saveAndOpenDialog(shoot.id, "role")
                        : openDialog(shoot.id, "role")
                    }
                    className={classes.actionButton}
                  >
                    +Add Role
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    style={{ marginLeft: "10px" }}
                    onClick={e =>
                      dirty
                        ? saveAndOpenDialog(shoot.id, "crew")
                        : openDialog(shoot.id, "crew")
                    }
                    className={classes.actionButton}
                  >
                    +Add Crew
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    style={{ marginLeft: "10px" }}
                    onClick={this.copyToClipBoard}
                  >
                    Copy Shoot Link
                  </Button>
                </Fragment>
              </div>
            </div>
          )}
        </Hidden>

        {shoot &&
          activeCompany && (
            <ChangeRepresentativeDialog
              onClose={() => dispatch(toggleChangeRepresentativeDialog(false))}
              open={changeRepresentativeDialogOpen}
              activeManager={
                shoot.representative ? shoot.representative : "Robin Morton"
              }
              creators={
                authenticatedUser.companies.find(x => x.id === activeCompany)
                  ? authenticatedUser.companies.find(
                      x => x.id === activeCompany
                    ).managers
                  : []
              }
              changeActiveRepresentative={id =>
                onChangeActiveRepresentative(id)
              }
            />
          )}
        {shoot &&
          activeCompany && (
            <AddClientCompanyDialog
              origin="create_shoot"
              onSaveUser={res => {
                setState(
                  update(this.props.state, {
                    shoot: {
                      client_company: {
                        $set: res.id,
                      },
                    },
                    dirty: {
                      $set: true,
                    },
                  })
                )
              }}
            />
          )}
      </Fragment>
    )
  }
}

ShootIndex.contextType = Context

const mapStateToProps = state => {
  return {
    authenticatedUser: state.authentication.authenticatedUser,
    activeCompany: state.companies.activeCompany,
    dialogOpen: state.shoots.showDialog,
    changeRepresentativeDialogOpen: state.shoots.changeRepresentativeDialog,
  }
}

const connector = connect(mapStateToProps)

export default compose(withStyles(styles))(connector(ShootIndex))
